<script setup>
import { toRefs, ref } from 'vue';
import { watch } from '#imports';

const props = defineProps({
  withButton: {
    type: Boolean,
    default: false,
  },
  defaultValue: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['reset', 'search']);
const searchInput = ref('');
const { defaultValue } = toRefs(props);

searchInput.value = defaultValue.value;

function handlePerformSearch() {
  emit('search', searchInput.value);
}

watch(searchInput, (newValue, oldValue) => {
  if (newValue === '' && oldValue !== '') {
    emit('reset');
  }
});
</script>

<template>
  <form class="search" @submit.prevent="handlePerformSearch">
    <div class="search__form">
      <BaseInputText
        v-model="searchInput"
        class="search__input"
        placeholder="Поиск по разделу"
        type="search"
      />

      <ButtonComponent
        v-if="withButton"
        :is-button-disabled="!searchInput"
        button-caption="Найти"
        theme="purple"
        @onclick.prevent="handlePerformSearch"
      />
    </div>
  </form>
</template>

<style scoped lang="postcss">
.search {
  width: 100%;

  &__form {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  &__input {
    width: 100%;
  }
}
</style>
